import { StockPriceData } from "@repo/apis/stockprice";
import { ProductSummaries } from "@repo/apis/summaries";
/**
 * Sorts products so that those with `isInStock` true appear first,
 * followed by products that are out of stock or have undefined/null stock status.
 *
 * @param products - Array of StockPriceMappedProduct objects to sort.
 * @returns A new array with in-stock products first, preserving order within groups.
 */
export const productSortByStock = (
  products: (StockPriceData & ProductSummaries)[],
) => {
  return [...products].sort((a, b) => {
    const aInStock = Boolean(a.isInStock);
    const bInStock = Boolean(b.isInStock);
    if (aInStock === bInStock) return 0;
    return aInStock ? -1 : 1;
  });
};
